import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { authzAudience, authzScope } from "../../auth/auth0";
import axios from "axios";
import { useDispatch } from "react-redux";
import * as Sentry from "@sentry/react";
import { getTeamInformation } from "../../store/actions/team.actions";
import { AuthLoading } from "./AuthLoading";
import { AuthFail } from "./AuthFail";
import { useNavigate } from "react-router";
import {
  getManagerTeamList,
  selectManagerTeam,
} from "../../store/actions/manager.actions";
import { useSelector } from "react-redux";

const publicRoutes = new Set(["/", "/login"]);
const validRedirects = new Set(["/help-center"]);

const trimPathName = (pathname) => {
  if (pathname[pathname.length - 1] === "/") {
    return pathname.substring(0, pathname.length - 1);
  }
  return pathname;
};

export const Auth = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [authLoading, setAuthLoading] = useState(true);
  const [authFailed, setAuthFailed] = useState(false);
  const {
    user,
    isAuthenticated,
    isLoading,
    getAccessTokenSilently,
    getAccessTokenWithPopup,
    loginWithRedirect,
  } = useAuth0();
  const { teams } = useSelector(({ manager }) => manager);
  const {
    loading: { info },
    info: {
      display_name: teamName,
    }
  } = useSelector(({ team }) => team);


  const initialize = async (token) => {
    axios.defaults.headers.common["Authorization"] = token;
    Sentry.setUser(user?.email ? { email: user?.email } : null);
    await dispatch(getManagerTeamList());
  };

  const attachToken = async () => {
    setAuthLoading(true);
    setAuthFailed(false);
    // if (isAuthenticated) {
    try {
      const token = await getAccessTokenSilently();
      await initialize(token);
    } catch (e) {
      if (e.error === "consent_required") {
        try {
          const token = await getAccessTokenWithPopup({
            audience: authzAudience,
            scope: authzScope,
            prompt: "consent",
          });
          await initialize(token);
        } catch (e) {
          setAuthFailed(true);
        }
      }
    }
    // }
    setAuthLoading(false);
  };

  useEffect(() => {
    if (!isLoading) attachToken();
  }, [isLoading]);

  useEffect(() => {
    const teamId = localStorage.getItem("team-id");
    if (teamId && teams.length) {
      dispatch(selectManagerTeam(teamId, navigate));
    }
  }, [teams]);

  useEffect(() => {
    const path = window.location.pathname;
    if ((!isLoading && isAuthenticated && !authLoading)) {
      if (publicRoutes.has(path)) {
        navigate("/team-selection");
      }
    }

    if (!isLoading && !isAuthenticated && !authLoading) {
      if (!publicRoutes.has(path)) { 
        if (!validRedirects.has(trimPathName(path))) {
          navigate("/login");
        } else {
          // Only allow post login redirect to validRedirects paths
          loginWithRedirect({
            appState: { 
              returnTo: window.location.pathname + window.location.search },
            }
          );
        }
      }
    }
  }, [isLoading, isAuthenticated, authLoading])

  const authReady = !authLoading && !isLoading && (isAuthenticated || publicRoutes.has(window.location.pathname));

  return (
    <>
      {!authReady ? (
        authFailed ? <AuthFail /> : <AuthLoading />
      ) : (
        children
      )}
    </>
  );
};
